export const SITEMAP = '/sitemap';
export const NOT_FOUND = '/404';
export const MY_ACCOUNT = '/my-account';
export const LOGIN = '/login';
export const ACCEPT_INVITATION = '/accept-invitation/:username/:token';
export const CANCEL_PASSWORD_RESET = '/cancel-password-reset/:username/:token';
export const CHANGE_PASSWORD = '/change-password';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_PASSWORD = '/reset-password/:username/:token';

// export const EVACUATION = '/evacuation';
// export const EVACUATION_DIRECTORY_VIEW = '/evacuation/directory';
// export const EVACUATION_FLOOR_VIEW = '/evacuation/floor';

export const EVACUATION_DEMO = '/evacuation';
export const EVACUATION_ROLL_CALL = '/evacuation/roll-call/:siteId/:zoneId';

export const LIVE_VIEW = '/live-view';
export const LIVE_VIEW_FLOOR_VIEW = '/live-view/floor-view';
export const LIVE_VIEW_DIRECTORY = '/live-view/directory';
export const FACE_LIVE_VIEW = '/face-live-view';
export const REALTIME_VIEW = '/realtime-view';
export const FACE_VISITS = '/face-visits';
export const LIVE_EVACUATION = '/live-evacuation';

export const NAVIGATION = '/navigation';

export const SITE_MANAGER = '/site-manager';
export const SITE_MANAGER_NETOWRK = '/site-manager/network';
export const SITE_PLAN = '/site-manager/plan';
export const SITE_CREATE = '/site-manager/create';

export const OPERATORS = '/operators';
export const OPERATOR_EDIT = '/operators/:username/edit';
export const OPERATOR_INVITE = '/operators/invite';

export const CLIENT = '/client';
export const CLIENT_ADD = '/client/add';

export const CLIENT_CONFIG = '/clientconfig';
export const CLIENT_CONFIG_ADD = '/clientconfig/add';
export const CLIENT_CONFIG_EDIT = '/clientconfig/:targetClientId/edit';

export const SITE = '/site';
export const SITE_ADD = '/site/add';
export const SITE_EDIT = '/site/:siteId/targetclient/:targetClientId/edit';

export const DETECTABLE = '/detectable';
export const DETECTABLE_ADD = '/detectable/add';

export const SUMMARY = '/summary';

export const AGENT = '/agent';
export const AGENT_ADD = '/agent/add';

export const ZONE = '/zone';
export const ZONE_ADD = '/zone/add';
export const ZONE_EDIT = '/zone/:zoneId/targetclient/:targetClientId/site/:siteId/edit';

export const READER = '/reader';
export const READER_ADD = '/reader/add';
export const READER_EDIT = '/reader/:readerSn/site/:siteId/targetclient/:targetClientId/edit';

export const ANTENNA = '/antenna';
export const ANTENNA_ADD = '/antenna/add';

export const CAMERA = '/camera';
export const CAMERA_ADD = '/camera/add';
export const CAMERA_EDIT = '/camera/:cameraSn/targetclient/:targetClientId/edit';

export const PROFILE = '/profile';
export const PROFILE_ADD = '/profile/add';

export const CLIENT_REGISTRY = '/clients';
export const CLIENT_REGISTRY_ADD = '/clients/add';

export const ATTENDANCE = '/attendance';
export const ATTENDANCE_SCHEDULES = '/attendance/schedules';
export const ATTENDANCE_SCHEDULES_DETAIL = '/attendance/schedules/:scheduleId';
export const ATTENDANCE_SCHEDULES_BLOCK_DRILLDOWN =
	'/attendance/schedules/:scheduleId/:clientReference';
export const ATTENDANCE_REPORTS = '/attendance/reports';
export const ATTENDANCE_CUSTOM_REPORTS = '/attendance/custom-reports';

export const DIRECTORY = '/directory';
export const DIRECTORY_HOLDER_DETAIL = '/directory/:clientReference';
export const DIRECTORY_HOLDER_NEW = '/directory/new';
export const DIRECTORY_HOLDER_EDIT = '/directory/:clientReference/edit';

export const REPORTS = '/reports';
export const QLIKDASHBOARD = '/qlikdashboard';
export const QLIKVISITORQUERY = '/qlikvisitorquery';
export const QLIKCOMPANYQUERY = '/qlikcompanyquery';
export const QLIKVISITORLIST = '/qlikvisitorlist';
export const QLIKMAP = '/qlikmap';
export const QLIKVISITANALYSIS = '/qlikvisitanalysis';
export const QLIKSAASCHARGES = '/qliksaascharges';
export const QLIKCLARENDONDASHBOARD = '/qlik-reports/clarendon/dashboard';
export const QLIKCLARENDONVISITORQUERY = '/qlik-reports/clarendon/visitorquery';
export const QLIKCLARENDONVISITORLIST = '/qlik-reports/clarendon/visitorlist';
export const QLIKCLARENDONCOMPANYQUERY = '/qlik-reports/clarendon/companyquery';
export const QLIKCLARENDONMAP = '/qlik-reports/clarendon/map';
export const QLIKCLARENDONVISITANALYSIS = '/qlik-reports/clarendon/visitanalysis';
export const QLIKGROUCHODASHBOARD = '/qlik-reports/groucho/dashboard';
export const QLIKGROUCHOVISITORQUERY = '/qlik-reports/groucho/visitorquery';
export const QLIKGROUCHOVISITORLIST = '/qlik-reports/groucho/visitorlist';
export const QLIKGROUCHOCOMPANYQUERY = '/qlik-reports/groucho/saascharges';
export const QLIKGROUCHOMAP = '/qlik-reports/groucho/map';
export const QLIKGROUCHOVISITANALYSIS = '/qlik-reports/groucho/visitanalysis';
export const QLIKTASUDASHBOARD = '/qlik-reports/tasu/dashboard';
export const QLIKTASUCOMPANYQUERY = '/qlik-reports/tasu/companyquery';
export const QLIKTASUVISITORQUERY = '/qlik-reports/tasu/visitorquery';
export const QLIKTASUVISITORLIST = '/qlik-reports/tasu/visitorlist';
export const QLIKTASUSAASCHARGES = '/qlik-reports/tasu/saascharges';
export const QLIKTASUMAP = '/qlik-reports/tasu/map';
export const QLIKTASUVISITANALYSIS = '/qlik-reports/tasu/visitanalysis';
export const QLIKTSBDASHBOARD = '/qlik-reports/tsb/dashboard';
export const QLIKTSBVISITORQUERY = '/qlik-reports/tsb/visitorquery';
export const QLIKTSBVISITORLIST = '/qlik-reports/tsb/visitorlist';
export const QLIKTSBFUNCTIONQUERY = '/qlik-reports/tsb/functionquery';
export const QLIKTSBMAP = '/qlik-reports/tsb/map';
export const QLIKTSBVISITANALYSIS = '/qlik-reports/tsb/visitanalysis';
export const QLIK25EPCAMERACOUNTING = '/qlik-reports/25ep/cameracounting';
export const QLIK25EPDASHBOARD = '/qlik-reports/25ep/dashboard';
export const QLIK25EPVISITORQUERY = '/qlik-reports/25ep/visitorquery';
export const QLIK25EPVISITORLIST = '/qlik-reports/25ep/visitorlist';
export const QLIK25EPFUNCTIONQUERY = '/qlik-reports/25ep/functionquery';
export const QLIK25EPMAP = '/qlik-reports/25ep/map';
export const QLIK25EPVISITANALYSIS = '/qlik-reports/25ep/visitanalysis';

export const QLIKTSBMAGNOXDASHBOARD = '/qlik-reports/tsbmagnox/dashboard';
export const QLIKTSBMAGNOXVISITORQUERY = '/qlik-reports/tsbmagnox/visitorquery';
export const QLIKTSBMAGNOXVISITORLIST = '/qlik-reports/tsbmagnox/visitorlist';
export const QLIKTSBMAGNOXMAP = '/qlik-reports/tsbmagnox/map';
export const QLIKTSBMAGNOXVISITANALYSIS = '/qlik-reports/tsbmagnox/visitanalysis';

export const QLIKTSBGRESHAMDASHBOARD = '/qlik-reports/tsbgresham/dashboard';
export const QLIKTSBGRESHAMVISITORQUERY = '/qlik-reports/tsbgresham/visitorquery';
export const QLIKTSBGRESHAMVISITORLIST = '/qlik-reports/tsbgresham/visitorlist';
export const QLIKTSBGRESHAMFUNCTIONQUERY = '/qlik-reports/tsbgresham/functionquery';
export const QLIKTSBGRESHAMMAP = '/qlik-reports/tsbgresham/map';
export const QLIKTSBGRESHAMVISITANALYSIS = '/qlik-reports/tsbgresham/visitanalysis';

export const QLIKTSBKEYPOINTDASHBOARD = '/qlik-reports/tsbkeypoint/dashboard';
export const QLIKTSBKEYPOINTVISITORQUERY = '/qlik-reports/tsbkeypoint/visitorquery';
export const QLIKTSBKEYPOINTVISITORLIST = '/qlik-reports/tsbkeypoint/visitorlist';
export const QLIKTSBKEYPOINTFUNCTIONQUERY = '/qlik-reports/tsbkeypoint/functionquery';
export const QLIKTSBKEYPOINTMAP = '/qlik-reports/tsbkeypoint/map';
export const QLIKTSBKEYPOINTVISITANALYSIS = '/qlik-reports/tsbkeypoint/visitanalysis';

export const QLIKGLENEAGLESDASHBOARD = '/qlik-reports/gleneagles/dashboard';
export const QLIKGLENEAGLESCOMPANYQUERY = '/qlik-reports/gleneagles/companyquery';
export const QLIKGLENEAGLESVISITORQUERY = '/qlik-reports/gleneagles/visitorquery';
export const QLIKGLENEAGLESVISITORLIST = '/qlik-reports/gleneagles/visitorlist';
export const QLIKGLENEAGLESMAP = '/qlik-reports/gleneagles/map';
export const QLIKGLENEAGLESVISITANALYSIS = '/qlik-reports/gleneagles/visitanalysis';


export const NOTIFICATIONS = '/notifications';
export const NOTIFICATIONS_EDIT = '/notifications/edit/:id';
export const NOTIFICATIONS_ADD = '/notifications/add/:id';

export const IMPORTS = '/imports';

export const MFA_SETTINGS = '/mfa-settings';

export default null;



// WEBPACK FOOTER //
// ./src/config/routes.js